import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import GroupImageUploadIcon from 'web/assets/svg/GroupImageUploadIcon'
import {
  profileImage, imageShow
} from 'redux/actions/profile';
import {
  groupImage
} from 'redux/actions/myNetwork';
const GroupPicture = ({ name, props, gruopType, networkId, groupListResponse, index, profileImagePath, callBackImg, callBackClickEvent, cancelPopupCallBack, Picture, ProfileName, CompanyName, pageType }) => {
  const [userImage, setUserImage] = useState();
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');

  let setProfilePic;
  if (profileImagePath === undefined) {
    setProfilePic = Picture
  } else {
    setProfilePic = process.env.REACT_APP_API_URL + '/user/image/' + profileImagePath
  }

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const getProfilePic = () => {
    callBackClickEvent()
    document.getElementById('getGroupFile' + networkId).click();
  };
  const onImgChange = (e, networkId) => {
    e.preventDefault();
    const maxFileSize = 10 * 1024 * 1024;
    let acceptFiles = "image/png,image/jpeg";
    let errorMsg = "File type must be .PNG, .JPG";
    const fileTypes = acceptFiles.split(',');
    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (file && fileTypes.includes(file.type)) {
        if (file.size > maxFileSize) {
          setModalContent('File size is too large.');
          setModalLink('');
          toggleModal();
          return;
        }
        if (file.type !== 'application/msword') {
          reader.onloadend = () => {
          };
          reader.readAsDataURL(file);
          if (name === "groupImg") {
            setUserImage(file);
            callBackImg(file)
          } else {
            profileImageApi(file, networkId)
          }

          if (pageType !== "Network") {
            const { setFieldError, setFieldValue } = props;
            setFieldValue(name, file)
          }
        } else {
          setModalContent(errorMsg);
          setModalLink('');
          toggleModal();
        }
      } else {
        setModalContent(errorMsg);
        setModalLink('');
        toggleModal();
      }
    }
  };

  const profileImageApi = async (profileImg, networkId) => {
    let formData = new FormData();

    let response;
    if (gruopType === "update") {
      formData.append('networkImage', profileImg);
      response = await dispatch(groupImage(networkId, formData, token));
    } else {
      formData.append('profileImage', profileImg);
      response = await dispatch(profileImage(formData, token));
    }

    if (response.status === 'SUCCESS') {
      if (gruopType === "update") {
        callBackImg(profileImg)
      }

      setUserImage(profileImg);
      setModalContent(response.message);
      setModalLink('');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const [profileImageUrl, setProfileImage] = useState();
  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let imgResponse = '';
      if (profileImagePath) {
        imgResponse = await dispatch(imageShow(profileImagePath, token));
      }

      setProfileImage(imgResponse)
    }
  }, []);

  useEffect(() => {
    fetchMyAPI();
  }, [fetchMyAPI]);

  const checkIt = () => {
    cancelPopupCallBack()
  }
  return (
    <>
      <Container>
        <PictureBox>
          {profileImageUrl || userImage ? <img src={
            userImage
              ? URL.createObjectURL(userImage)
              : setProfilePic
          }
            alt=""
          /> : <img
            src={userImage && profileImagePath ? URL.createObjectURL(userImage) : setProfilePic}
            alt=""
          />}
          <InputFile>
            <input
              onChange={(e) => onImgChange(e, networkId)}
              acceptFiles="image/png,image/jpeg"
              errorMsg="File type must be .PNG, .JPG"
              multiple
              type='file'
              name="name"
              id={'getGroupFile' + networkId}
              onClick={(event) => {
                document.body.onfocus = checkIt;
              }}
            />
          </InputFile>
        </PictureBox>
        <ProfileData>
        </ProfileData>
      </Container>

      <Upload onClick={getProfilePic}>
        <GroupImageUploadIcon className='image-upload-icon' />
      </Upload>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  )
}


export default GroupPicture;

const Container = styled.div`
    text-align: center; 
`
const Upload = styled.div`
    flex: unset;
    position: absolute;
    right: 0;
    left: 0 ma;
    left: 0;
    margin: 0 auto;
    max-width: 110px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor:pointer;
    svg {
        font-size: 40px;
        color: #fff;
        background: #00000075;
        border-radius: 50%;
    }
`
const InputFile = styled.div`
   display:none;
`
const PictureBox = styled.div`
    img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
    }
`
const ProfileData = styled.div`
  h3 {
    font-size: 24px;
    font-family: "latobold";
    text-transform: capitalize;
  }
`;